import axios from 'axios'

import { TemplatePage } from './types'

import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '~/api/results'

export function createDeliveryTemplatePageModule({
  sentry,
  city,
}: {
  sentry: any
  city: string
}) {
  return {
    async fetchTemplatePage(templateSlug: string) {
      const { API_BASE_URL, BRAND_UUID, VARITI_TOKEN } =
        useRuntimeConfig().public

      try {
        const { data } = await axios.get<TemplatePage>(
          `${API_BASE_URL}/v4/${BRAND_UUID}/${city}/template-page/area/${templateSlug}/`,
          {
            headers: {
              ...getAxiosGlobalHeader({ varitiToken: VARITI_TOKEN }),
            },
          },
        )

        return new Success(data)
      } catch (error) {
        switch (error?.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Шаблонная страница не найдена')
          default:
            sentry.captureException(
              `Не удалось загрузить шаблонную страницу: ${error}`,
            )
            return new ServerError(error)
        }
      }
    },
  }
}
